import { useEffect } from 'react';
import { log } from 'log';
import { prop, pick } from 'ramda';
import { useUserSelector, useAuthSelector, useLottoSelector, useSocketSelector } from 'js/store/hooks';

export const useLottoSyncSession = () => {
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const {
        isAppInitialized,
        isRenderingStarted
    } = useLottoSelector(pick(['isAppInitialized', 'isRenderingStarted']));
    const {
        isLogoutInProcess,
        isLoginInProcess,
        wasAutoLoginCompleted
    } = useAuthSelector(pick(['isLogoutInProcess', 'isLoginInProcess', 'wasAutoLoginCompleted']));
    const connected = useSocketSelector(prop('connected'));

    useEffect(() => {
        if (isLogoutInProcess || isLoginInProcess || !wasAutoLoginCompleted) {
            return;
        }

        if (!connected || !isAppInitialized || !isRenderingStarted) {
            return;
        }

        try {
            window.Lotto?.sendMessage('SYNC_SESSION');
        } catch (error) {
            log('log', '[LOTTO | Portal] sync session error', error);
        }
    }, [
        connected,
        isAppInitialized,
        isLoggedIn,
        isLoginInProcess,
        isLogoutInProcess,
        isRenderingStarted,
        wasAutoLoginCompleted
    ]);
};
